export default "__VITE_ASSET__GLVuy4_O__"